/** Shareable template codes — "PTPL1." + base64(UTF-8 JSON). */
const CODE_PREFIX = "PTPL1.";

export function encodeTemplate(t) {
  const json = JSON.stringify({ name: t.name, ...t.payload });
  return CODE_PREFIX + btoa(unescape(encodeURIComponent(json)));
}

export function decodeTemplate(code) {
  const raw = code.trim();
  if (!raw.startsWith(CODE_PREFIX)) throw new Error("format");
  const json = decodeURIComponent(escape(atob(raw.slice(CODE_PREFIX.length))));
  const parsed = JSON.parse(json);
  const { name, ...payload } = parsed;
  if (!name || !payload) throw new Error("contenu");
  return { name, payload };
}
